import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.removeUploadButton();
  }

  removeUploadButton() {
    this.element.toolbarElement
      ?.querySelector('[data-trix-button-group="file-tools"]')
      ?.remove();
  }

  rejectFile(event) {
    event.preventDefault();
  }
}
